import { useState } from "react";
import "../../styling/Dashboard.css";
import axios from "axios";
import { useContext } from "react";
import { EventDataContext } from "../EventDataContext";
import { useEffect } from "react";
import CancelEventClientModal from "../modals/CancelEventClientModal";
import defaultPic from "../../images/defaultPic.svg";

const OverviewRightPanelClient = ({brandingColours, businessId}) => {
  const { EventData, setEventData } = useContext(EventDataContext);

  const [paymentIntentId, setPaymentIntentId] = useState("");
  const [deductionAmount, setDeductionAmount] = useState("");
  const [refundDetails, setRefundDetails] = useState(null);
  const [error, setError] = useState(null);
  const [chosenPackage, setChosenPackage]=useState(null);
  const [addons, setAddons]=useState([])
  const [members, setMembers]=useState([]) 

  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
  };

  const handleRefund = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-refund`, {
        paymentIntentId,
        deductionAmount: parseFloat(deductionAmount),
      });

      setRefundDetails(response.data);
      setError(null);
    } catch (err) {
      setError(err.response ? err.response.data.error : "An error occurred");
      setRefundDetails(null);
    }
  };


  useEffect(() => {
    if (EventData?.packageId) {
      fetchPackage();
    }

    if(EventData?.addonIds) {
      fetchAddons();
    }
  }, [EventData]); 

  const fetchPackage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getPackageDetail/${EventData.packageId}`,
        { withCredentials: true }
      );
      
      setChosenPackage(response.data);

    } catch (error) {
      console.log(error)
    }
  };

const fetchAddons = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/business/getAddonDetail/${EventData._id}`,
          { withCredentials: true }
        );
        
        setAddons(response.data.addons);
  
      } catch (error) {
        console.log(error)
      }
    };

  const addonCost = addons?.reduce((sum, item) => sum + (item.cost || 0), 0);

     const fetchTeamMembers = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/client/event/teamMembers/${EventData._id}`,{withCredentials: true});
        setMembers(res.data.teamMembers); // Assuming response is { members: [...] }
      } catch (error) {
        console.error("Failed to fetch team members", error);
      }
    };

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  return (
    <div>
      <div>
        <div className="right-panel-content">
          <div className="event-total-div">
            <div className="overview-event-name">
              <h2 style={{marginBottom: '0px', marginTop: '0px'}}>John's Birthday Party 6</h2>
              <span style={{ color: '#625C73', }}>
              Date Booked: March 11, 2023
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
              className="event-total-box"
            >
              <div>
                <h4
                  style={{
                    color: "#000000",
                    marginTop: "0px",
                    marginBottom: "5px",
                    fontWeight: "400",
                  }}
                >
                  Event Total:
                </h4>
                <h1
                  style={{
                    color: "#000000",
                    marginBottom: "20px",
                    marginTop: "5px",
                  }}
                >
                 $ {EventData?.expPaymentAmount}
                </h1>
              </div>
              <div
                style={{
                  backgroundColor: EventData.payment === 'paid' ? '#E1FAE3' : '#FDDCDC',
                  color: EventData.payment === 'paid' ? '#21A62C' : '#FF0000',
                  padding: "10px",
                  height: "20px",
                  marginRight: "20px",
                  alignSelf: "initial",
                }}
              >
                {EventData.payment === 'paid' ? 'Paid' : 'Pending'}
              </div>
            </div>
            <button
              style={{
                width: "100%",
                height: "35px",
                marginLeft: "1%",
                marginBottom: "3%",
                color: brandingColours?.secondaryColor,
                fontWeight: "400",
                fontSize: "15px",
                background: brandingColours?.primaryColor ,
                border: "1px solid #D9D9D9",
                cursor: "pointer",
              }}
              className="cancel-btn-overview"
              onClick={()=> setIsOpen(true)}
            >
              Cancel or Reschedule
            </button>
            <CancelEventClientModal isOpen={isOpen} closeModal={closeModal} businessId={businessId}/>
          </div>
        </div>
        <div className="package-addOn-div">
            <div className="overview-package">
        <div
          className="right-panel-content"
          style={{ marginTop: "0px", borderTop: "hidden" }}
        >
          <div className="right-panel-arrow-container">
            <span>
              <h4
                style={{
                  color: "#000000",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "400",
                }}
              >
                {chosenPackage?.name}
              </h4>
            </span>{" "}
            <div
              style={{
                alignSelf: "flex-end",
                fontSize: "15px",
                marginRight: "10px",
                marginBottom: "5px",
                color: "#0000004",
                fontWeight: "400",
              }}
            >
             $ {chosenPackage?.cost}
            </div>
          </div>

          <div style={{ color: "#625C73", whiteSpace: "pre-wrap" }}>
            <p style={{ marginBottom: "3px" }}>{chosenPackage?.description}</p>
          </div>
        </div>
        </div>
        <div className="overview-addOns">
         <div
    className="right-panel-content"
    style={{ marginTop: "0px", borderTop: "hidden" }}
  >
    <div className="right-panel-arrow-container">
      <span>
        <h4
          style={{
            color: "#000000",
            marginTop: "0px",
            marginBottom: "5px",
            fontWeight: "400",
          }}
        >
          Add Ons
        </h4>
      </span>{" "}
      <div
        style={{
          alignSelf: "flex-end",
          fontSize: "15px",
          marginRight: "10px",
          marginBottom: "5px",
          color: "#0000004",
          fontWeight: "400",
        }}
      >
        $ {addonCost}
      </div>
    </div>

{addons?.map((item, index) => (
    <div style={{ color: "#625C73", whiteSpace: "pre-wrap"}}  key={index}>
      <p>{item.name}</p>
    </div>
    ))}
    
  </div>

        </div>
        </div>
      </div>


      <div
        style={{
          width: "89.5%",
          border: "1px solid #D9D9D9",
          borderTop: "none",
          padding: "5%",
        }}
        className="overview-members-container"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            width: "87%",
          }}
        >
          <h4
            style={{
              fontWeight: "800",
              color: "#000000",
              marginTop: "0px",
              fontSize: "15px",
            }}
          >
            {" "}
            Assigned Team Members
          </h4>
        </div>
          <div style={{ marginTop: "12px" }}>
            {Array.isArray(members) && members.length > 0 ? (
              members.map((member, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                    padding: "6px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginRight: "12px",
                      width: "50px",
                      height: "50px",
                      flexShrink: 0,
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <img
                      src={member.profilePic || defaultPic}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                  <div>
                    <h4 style={{ margin: 0, fontWeight: "500", color: "#000" }}>
                      {member.firstName + " " + member.lastName}
                    </h4>
                    <p style={{ margin: 0, color: "#625C73", fontSize: "14px" }}>

                      {member.designation || "Booth Attendant"}

                    </p>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: "#888", marginTop: "8px" }}>
                No team members assigned.
              </p>
            )}
          </div>
      </div>
    </div>
  );
};

export default OverviewRightPanelClient;
